import styled from 'styled-components';

const Editor = styled.div`
  width: 100%;
`;

export default Editor;
